document.addEventListener('DOMContentLoaded', function () {
  var roots = document.querySelectorAll('.photo-letter-content[data-photo-letter-content]');
  var MODE_MAP = {
    'photo-mosaic': 'photo-mosaic',
    'film-roll': 'film-roll',
    'photo-grid': 'photo-grid'
  };

  function isDebugEnabled() {
    return window.PhotoLetterDebug === true || window.localStorage.getItem('PhotoLetterDebug') === 'true';
  }

  function debugLog() {
    if (!isDebugEnabled()) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[PhotoLetter]');
    console.log.apply(console, args);
  }

  roots.forEach(function (root) {
    if (!root || root.dataset.photoLetterGrouped === 'true') return;

    var blocks = Array.prototype.slice.call(root.children);
    var pendingMode = null;
    var imageBlockCount = 0;
    var groupsCreated = 0;

    for (var i = 0; i < blocks.length; i += 1) {
      var current = blocks[i];
      var inlineMarker = extractInlineMarker(current);
      if (inlineMarker) {
        pendingMode = inlineMarker;
        debugLog('marker detected (inline):', inlineMarker);
      }

      var markerOnly = parseModeToken(current);
      if (markerOnly) {
        pendingMode = markerOnly;
        current.remove();
        debugLog('marker detected (token):', markerOnly);
        continue;
      }

      var groupCandidates = collectAdjacentImageBlocks(blocks, i);
      if (!groupCandidates.length) continue;

      i += groupCandidates.length - 1;

      var extracted = groupCandidates.map(function (candidate) {
        return {
          block: candidate,
          nodes: extractImageNodes(candidate)
        };
      }).filter(function (entry) {
        return entry.nodes.length > 0;
      });

      var imageCount = extracted.reduce(function (sum, entry) {
        return sum + entry.nodes.length;
      }, 0);
      if (!imageCount) continue;

      imageBlockCount += extracted.length;

      var resolvedMode = resolveGroupMode(imageCount, pendingMode);
      var wrapper = document.createElement('div');
      wrapper.className = 'photo-letter-image-group ' + resolvedMode.baseClass;
      if (resolvedMode.extraClass) wrapper.classList.add(resolvedMode.extraClass);

      var anchor = groupCandidates[0];
      root.insertBefore(wrapper, anchor);

      extracted.forEach(function (entry) {
        entry.nodes.forEach(function (node) {
          var item = document.createElement('div');
          item.className = 'photo-letter-image-item';
          if (resolvedMode.itemClass) item.classList.add(resolvedMode.itemClass);
          item.appendChild(node);
          wrapper.appendChild(item);
        });

        if (!entry.block.querySelector('img')) {
          entry.block.remove();
        }
      });

      pendingMode = null;
      groupsCreated += 1;
      debugLog('group created:', {
        blockCount: extracted.length,
        imageCount: imageCount,
        mode: resolvedMode.debugMode
      });
    }

    root.dataset.photoLetterGrouped = 'true';
    root.querySelectorAll('blockquote').forEach(function (quote) {
      quote.classList.add('photo-letter-poem');
    });

    debugLog('detected image blocks:', imageBlockCount);
    debugLog('created groups:', groupsCreated);
  });

  var lightbox = createLightbox();
  if (lightbox) {
    roots.forEach(function (root) {
      attachLightboxHandlers(root, lightbox);
    });
  }

  function attachLightboxHandlers(root, lightboxElements) {
    if (!root || !lightboxElements) return;

    var clickableImages = root.querySelectorAll('img');
    clickableImages.forEach(function (img) {
      if (!img || img.dataset.photoLetterLightboxBound === 'true') return;
      img.dataset.photoLetterLightboxBound = 'true';

      img.addEventListener('click', function (event) {
        if (shouldDisableLightbox(img)) return;
        event.preventDefault();
        openLightbox(img, lightboxElements);
      });
    });
  }

  function shouldDisableLightbox(img) {
    if (!img) return true;
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var isInFilmRoll = img.closest('.photo-letter-film-roll, .photo-letter-image-group--roll');
    return isMobile && Boolean(isInFilmRoll);
  }

  function createLightbox() {
    if (document.querySelector('.photo-letter-lightbox')) {
      return {
        root: document.querySelector('.photo-letter-lightbox'),
        backdrop: document.querySelector('.photo-letter-lightbox__backdrop'),
        image: document.querySelector('.photo-letter-lightbox__image'),
        caption: document.querySelector('.photo-letter-lightbox__caption')
      };
    }

    var lightboxRoot = document.createElement('div');
    lightboxRoot.className = 'photo-letter-lightbox';
    lightboxRoot.setAttribute('role', 'dialog');
    lightboxRoot.setAttribute('aria-modal', 'true');
    lightboxRoot.setAttribute('aria-hidden', 'true');

    var backdrop = document.createElement('button');
    backdrop.type = 'button';
    backdrop.className = 'photo-letter-lightbox__backdrop';
    backdrop.setAttribute('aria-label', '拡大画像を閉じる');

    var inner = document.createElement('div');
    inner.className = 'photo-letter-lightbox__inner';

    var closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'photo-letter-lightbox__close';
    closeButton.setAttribute('aria-label', '拡大画像を閉じる');
    closeButton.textContent = '×';

    var image = document.createElement('img');
    image.className = 'photo-letter-lightbox__image';
    image.alt = '';

    var caption = document.createElement('p');
    caption.className = 'photo-letter-lightbox__caption';
    caption.hidden = true;

    inner.appendChild(closeButton);
    inner.appendChild(image);
    inner.appendChild(caption);

    lightboxRoot.appendChild(backdrop);
    lightboxRoot.appendChild(inner);
    document.body.appendChild(lightboxRoot);

    function closeFromControl() {
      closeLightbox({ root: lightboxRoot, image: image, caption: caption });
    }

    backdrop.addEventListener('click', closeFromControl);
    closeButton.addEventListener('click', closeFromControl);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!lightboxRoot.classList.contains('is-open')) return;
      closeFromControl();
    });

    return { root: lightboxRoot, backdrop: backdrop, image: image, caption: caption };
  }

  function openLightbox(sourceImage, lightboxElements) {
    if (!sourceImage || !lightboxElements || !lightboxElements.root) return;

    var src = sourceImage.currentSrc || sourceImage.src;
    if (!src) return;

    lightboxElements.image.src = src;
    lightboxElements.image.alt = sourceImage.alt || '';

    var captionText = getCaptionText(sourceImage);
    if (captionText) {
      lightboxElements.caption.textContent = captionText;
      lightboxElements.caption.hidden = false;
    } else {
      lightboxElements.caption.textContent = '';
      lightboxElements.caption.hidden = true;
    }

    lightboxElements.root.classList.add('is-open');
    lightboxElements.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('photo-letter-lightbox-open');
  }

  function closeLightbox(lightboxElements) {
    if (!lightboxElements || !lightboxElements.root) return;
    lightboxElements.root.classList.remove('is-open');
    lightboxElements.root.setAttribute('aria-hidden', 'true');
    lightboxElements.image.removeAttribute('src');
    lightboxElements.image.alt = '';
    lightboxElements.caption.textContent = '';
    lightboxElements.caption.hidden = true;
    document.body.classList.remove('photo-letter-lightbox-open');
  }

  function getCaptionText(img) {
    if (!img) return '';

    var figure = img.closest('figure');
    if (figure) {
      var figcaption = figure.querySelector('figcaption');
      if (figcaption) return (figcaption.textContent || '').trim();
    }

    return '';
  }


  function collectAdjacentImageBlocks(blocks, startIndex) {
    var group = [];
    for (var idx = startIndex; idx < blocks.length; idx += 1) {
      var block = blocks[idx];
      if (parseModeToken(block)) break;
      if (!isImageBlock(block)) break;
      if (group.length > 0 && hasInlineMarkerText(block)) break;
      group.push(block);
    }
    return group;
  }



  function hasInlineMarkerText(el) {
    if (!el || el.nodeType !== 1) return false;
    var text = (el.textContent || '').replace(/\s+/g, '').toLowerCase();
    return /^\[(photo-mosaic|film-roll|photo-grid)\]/i.test(text);
  }

  function resolveGroupMode(length, pendingMode) {
    if (length === 1) return { baseClass: 'photo-letter-image-group--single', debugMode: 'single' };
    if (length === 2) return { baseClass: 'photo-letter-image-group--double', debugMode: 'double' };
    if (pendingMode === 'film-roll') return { baseClass: 'photo-letter-image-group--roll', extraClass: 'photo-letter-film-roll', debugMode: 'film-roll' };
    if (pendingMode === 'photo-grid') return { baseClass: 'photo-letter-image-group--photo-grid', extraClass: 'photo-letter-photo-grid', itemClass: 'photo-letter-grid-item', debugMode: 'photo-grid' };
    return { baseClass: 'photo-letter-image-group--photo-mosaic', extraClass: 'photo-letter-photo-mosaic', itemClass: 'photo-letter-mosaic-item', debugMode: 'photo-mosaic' };
  }

  function parseModeToken(el) {
    if (!el || el.nodeType !== 1) return null;
    if (!el.matches('p, div')) return null;
    if (el.querySelector('img, figure, figcaption')) return null;

    var text = (el.textContent || '').replace(/\s+/g, '').toLowerCase();
    var match = text.match(/^\[(photo-mosaic|film-roll|photo-grid)\]$/i);
    return match ? MODE_MAP[match[1].toLowerCase()] : null;
  }

  function extractInlineMarker(el) {
    if (!el || el.nodeType !== 1 || !el.querySelector('img')) return null;
    var text = (el.textContent || '').replace(/\s+/g, '').toLowerCase();
    var match = text.match(/^\[(photo-mosaic|film-roll|photo-grid)\]/i);
    if (!match) return null;

    removeMarkerText(el, match[0]);
    return MODE_MAP[match[1].toLowerCase()] || null;
  }

  function removeMarkerText(root, markerText) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var target = null;
    while ((target = walker.nextNode())) {
      var raw = target.nodeValue || '';
      var compact = raw.replace(/\s+/g, '').toLowerCase();
      if (compact.indexOf(markerText.toLowerCase()) === 0) {
        var replaced = raw.replace(/^[\s\u00a0]*\[(photo-mosaic|film-roll|photo-grid)\][\s\u00a0]*/i, '');
        target.nodeValue = replaced;
        break;
      }
    }
  }

  function isImageBlock(el) {
    if (!el || el.nodeType !== 1 || !el.querySelector('img')) return false;
    return hasOnlyImageLikeContent(el) || extractInlineMarkerPreview(el);
  }

  function extractInlineMarkerPreview(el) {
    var text = (el.textContent || '').replace(/\s+/g, '').toLowerCase();
    return /^\[(photo-mosaic|film-roll|photo-grid)\]/i.test(text);
  }

  function hasOnlyImageLikeContent(el) {
    var clone = el.cloneNode(true);
    clone.querySelectorAll('script, style, noscript, meta').forEach(function (node) { node.remove(); });
    var walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT);
    var textNode;
    while ((textNode = walker.nextNode())) {
      var cleaned = (textNode.nodeValue || '').replace(/\s+/g, '');
      if (cleaned !== '' && !/^\[(photo-mosaic|film-roll|photo-grid)\]$/i.test(cleaned)) return false;
    }
    var blockedNodes = clone.querySelectorAll('h1,h2,h3,h4,h5,h6,ul,ol,li,blockquote,table,pre,code');
    return blockedNodes.length === 0 && clone.querySelector('img') !== null;
  }

  function extractImageNodes(block) {
    var nodes = [];

    if (block.matches('figure') && block.querySelector('img')) {
      return [block];
    }

    var directFigures = Array.prototype.slice.call(block.querySelectorAll(':scope > figure')).filter(function (figure) {
      return figure.querySelector('img');
    });
    if (directFigures.length > 0) {
      return directFigures;
    }

    Array.prototype.slice.call(block.querySelectorAll('img')).forEach(function (img) {
      var figure = img.closest('figure');
      if (figure && block.contains(figure)) {
        addUniqueNode(nodes, figure);
        return;
      }

      var anchor = img.closest('a');
      if (anchor && block.contains(anchor)) {
        addUniqueNode(nodes, anchor);
        return;
      }

      addUniqueNode(nodes, img);
    });

    return nodes;
  }

  function addUniqueNode(nodes, node) {
    if (nodes.indexOf(node) === -1) nodes.push(node);
  }
});
